<template>
    <div>
        <div><CustomLoader v-if="isLoading" :width="70" /></div>

        <b-card class="mainCardBG">
            <b-card-text>
                <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;" toggleable="lg" type="dark" variant="primary">
                    <b-navbar-nav>
                        <b-button @click="goBack" size="sm" variant="light"> <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back </b-button>
                    </b-navbar-nav>
                    <b-navbar-brand center>System Configuration</b-navbar-brand>
                    <b-navbar-nav class="ml-auto"></b-navbar-nav>
                </b-navbar>

                <b-container fluid>
                    <b-row>
                        <b-col cols="12">
                            <b-card class="formCard">
                                <b-card-text>
                                    <b-row>
                                    <!-- v-if="($sessionsStorage.get('designation') == 'Admin' || BillingShowList.length > 0) && isEconomicYear && BillingActiveStatus" -->
                                        <b-col md="2" class="mb-1" >
                                            <label>Billing Start Date</label>
                                            <b-form-input :formatter="capitalizeAll" v-model="configration.config_bill_start_date" type="date" placeholder="Enter Billing Start Date" :min="$sessionsStorage.get('designation') == 'Admin'?'':calculateMinDate()" :max="$sessionsStorage.get('designation') == 'Admin'?'':calculateMaxDate()" />
                                        </b-col>
                                        <b-col md="2" class="mb-1">
                                            <label>Billing End Date</label>
                                            <b-form-input :formatter="capitalizeAll" v-model="configration.config_bill_end_date" type="date" placeholder="Enter Billing End Date" :min="$sessionsStorage.get('designation') == 'Admin'?'':calculateMinDate()" :max="$sessionsStorage.get('designation') == 'Admin'?'':calculateMaxDate()" />
                                        </b-col>
                                        <b-col md="2" class="mb-1">
                                            <label>Enter Billing Date</label>
                                            <b-form-input :formatter="capitalizeAll" v-model="configration.config_billing_date" type="date" placeholder="Enter Billing Date" :min="$sessionsStorage.get('designation') == 'Admin'?'':calculateMinDate()" :max="$sessionsStorage.get('designation') == 'Admin'?'':calculateMaxDate()" />
                                        </b-col>
                                        <b-col md="2">
                                            <label>Economic Year</label>
                                            <b-form-checkbox v-model="configration.is_economic_year" :value="1" :unchecked-value="0">Enable Economic Year</b-form-checkbox>
                                        </b-col>
                                        <b-col md="4" v-if="$sessionsStorage.get('designation') == 'Admin'">
                                            <label>Allowed Users</label>
                                            <multi-select
                                                :options="$store.getters['common/getAllUserList']"
                                                :selected-options="user_items"
                                                v-model="configration.multiple_user_id"
                                                placeholder="Select User"
                                                :multiple="true"
                                                id="User"
                                                @select="SelectMultiUser"
                                            />
                                        </b-col>
                                        <b-col cols="12" class="text-center mt-3">
                                            <b-button class="ml-2 mb-2 mt-4" @click="updateConfig()" size="sm" variant="outline-info"> Save</b-button>
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from "vue2-datepicker";
    import CustomLoader from "../common/customLoader.vue";
    import { ModelListSelect, MultiSelect } from "vue-search-select";
    import CommonService from "../../services/CommonService.js";
    import {
        globalPermissionStatus,
        lastVisitPage,
        GlobalGetLocation,
        } from "../../helper/collection";

    export default {
        beforeMount() {
            lastVisitPage(this.$router.history.current.fullPath);
            this.getConfig();
            this.$store.dispatch(
                "common/setAllUserList",
                JSON.stringify({
                    itemCode: "GET_USERLIST_Data",
                })
            );
            if (globalPermissionStatus("Accounts")) {
                this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
                if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                    this.fetchLastPage(this.lastVisitPage);
                } else {
                    this.getConfig();
                }
            } else {
                this.$router.push({
                    path: "/dashboard",
                });
            }
        },
        data() {
            return {
                lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
                isLoading: false,
                BillingShowList: [],
                configration: {
                    config_id: "",
                    config_billing_date: "",
                    config_bill_start_date: "",
                    config_bill_end_date: "",
                    is_economic_year: 1,

                    multiple_user_arr: [],
                    multiple_user_id: "",
                    userName: "",
                },
            };
        },
        computed: {
            isEconomicYear() {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1
                return (
                    currentMonth <= this.economicYearStartMonth ||
                    currentMonth <= this.economicYearEndMonth
                    // ||currentMonth <= this.economicYearEndMonth
                );
            },
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            calculateMinDate() {
                const currentDate = new Date();
                // Set the minimum date to tomorrow
                currentDate.setDate(currentDate.getDate());
                return currentDate.toISOString().split("T")[0];
            },
            calculateMaxDate() {
                // Set the maximum date to a future date if needed
                const maxDate = new Date();
                maxDate.setDate(maxDate.getDate() + 50); // Adjust the number of days as needed
                return maxDate.toISOString().split("T")[0];
            },
            SelectMultiUser(user_items, lastSelectItem) {
                this.user_items = user_items;
                console.log("user_items=>", this.user_items);

                this.configration.multiple_user_id = "";
                this.configration.userName = "";
                if (this.user_items) {
                    this.user_items.forEach((item_val) => {
                        if (this.configration.userName) {
                            this.configration.userName = this.configration.userName + "," + item_val.text;
                        } else {
                            this.configration.userName = item_val.text;
                        }

                        if (this.configration.multiple_user_id) {
                            this.configration.multiple_user_id = this.configration.multiple_user_id + "," + item_val.value;
                        } else {
                            this.configration.multiple_user_id = item_val.value;
                        }
                    });
                    console.log("configration=>", this.configration);
                }
                this.configration.multiple_user_arr = this.user_items;
            },
            updateConfig() {
                let payload = {};
                let multiple_user_arr = [];
                this.BillingShowList = [];

                if (this.user_items) {
                    this.configration.userName = "";
                    this.configration.multiple_user_id = "";
                    multiple_user_arr = [];
                    this.user_items.forEach((item_val) => {
                        let userObj = {};
                        if (this.configration.userName) {
                            this.configration.userName = this.configration.userName + "," + item_val.text;
                        } else {
                            this.configration.userName = item_val.text;
                        }

                        if (this.configration.multiple_user_id) {
                            this.configration.multiple_user_id = this.configration.multiple_user_id + "," + item_val.value;
                        } else {
                            this.configration.multiple_user_id = item_val.value;
                        }
                        userObj = { text: item_val.text, value: item_val.value };
                        multiple_user_arr.push(userObj);
                    });
                    if (multiple_user_arr.length > 0) {
                        this.configration.multiple_user_arr = multiple_user_arr;
                    }
                }
                console.log(" this.configration=>", this.configration);
                // return false;
                payload = {
                    itemCode: "updateConfig",
                    configration: this.configration,
                };

                CommonService.getAllJobList(payload)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        if (status == 200 && data.updateConfigFLAG == 1) {
                            this.BillingShowList = data.BillingShowList;
                            this.configration.config_id = data.Configurationrow.config_id;
                            this.configration.is_economic_year = parseInt(data.Configurationrow.is_economic_year);
                            this.configration.config_bill_start_date = data.Configurationrow.config_bill_start_date;
                            this.configration.config_billing_date = data.Configurationrow.config_billing_date;
                            this.configration.config_bill_end_date = data.Configurationrow.config_bill_end_date;
                            this.alert.content = data.updateConfigMSG;

                            if (data.Configurationrow.multiple_user_arr != "" && data.Configurationrow.multiple_user_arr != null) {
                                this.configration.multiple_user_arr = data.Configurationrow.multiple_user_arr;
                                this.user_items = data.Configurationrow.multiple_user_arr;
                                if (this.user_items) {
                                    this.user_items.forEach((item_val) => {
                                        if (this.configration.userName) {
                                            this.configration.userName = this.configration.userName + "," + item_val.text;
                                        } else {
                                            this.configration.userName = item_val.text;
                                        }

                                        if (this.configration.multiple_user_id) {
                                            this.configration.multiple_user_id = this.configration.multiple_user_id + "," + item_val.value;
                                        } else {
                                            this.configration.multiple_user_id = item_val.value;
                                        }
                                    });
                                    console.log("configration=>", this.configration);
                                }
                            } else {
                                this.configration.multiple_user_arr = [];
                                this.user_items = [];
                            }

                            console.log("this.configration.multiple_user_arr=>", this.configration.multiple_user_arr);
                            this.$refs["addPop"].open();
                        }
                    })
                    .catch((error) => {
                        console.log("Catch on updateConfig Error: ", error);
                    });
            },

            getConfig() {
                let payload = {};
                this.BillingShowList = [];
                payload = {
                    itemCode: "getConfig",
                    configration: this.configration,
                };

                CommonService.getAllJobList(payload)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        console.log();
                        if (status == 200 && data.getConfigFLAG == 1) {
                            console.log("data.Configurationrow=>", data.Configurationrow);
                            this.BillingShowList = data.BillingShowList;
                            this.configration.config_id = data.Configurationrow.config_id;
                            this.configration.is_economic_year = parseInt(data.Configurationrow.is_economic_year);
                            this.configration.config_bill_start_date = data.Configurationrow.config_bill_start_date;
                            this.configration.config_billing_date = data.Configurationrow.config_billing_date;
                            this.configration.config_bill_end_date = data.Configurationrow.config_bill_end_date;

                            if (data.Configurationrow.multiple_user_arr != "" && data.Configurationrow.multiple_user_arr != null) {
                                this.configration.multiple_user_arr = data.Configurationrow.multiple_user_arr;
                                this.user_items = data.Configurationrow.multiple_user_arr;
                                if (this.user_items) {
                                    this.user_items.forEach((item_val) => {
                                        if (this.configration.userName) {
                                            this.configration.userName = this.configration.userName + "," + item_val.text;
                                        } else {
                                            this.configration.userName = item_val.text;
                                        }

                                        if (this.configration.multiple_user_id) {
                                            this.configration.multiple_user_id = this.configration.multiple_user_id + "," + item_val.value;
                                        } else {
                                            this.configration.multiple_user_id = item_val.value;
                                        }
                                    });
                                    console.log("configration=>", this.configration);
                                }
                            } else {
                                this.configration.multiple_user_arr = [];
                                this.user_items = [];
                            }

                            console.log("this.configration.multiple_user_arr=>", this.configration.multiple_user_arr);
                        }
                    })
                    .catch((error) => {
                        console.log("Catch on getConfig Error: ", error);
                    });
            },
            //Added By Priyanshu SIngh Multi Select End
        },
        components: {
            DatePicker,
            CustomLoader,
            ModelListSelect,
            MultiSelect,
        },
    };
</script>

<style>
    .error {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// config.vue?9cf5f340